module.exports = __webpack_public_path__ + "static/cafe2-8ebe0139f35ff4dab9d94bbd1279e54c.jpg";